"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _context = require("../../context");

var _icons = require("../../icons");

var _utils = require("../../utils");

var _constants = require("../html/constants");

var _expandable = require("../expandable");

var _html = require("../html");

var _interfaces = require("../interfaces");

var _utils2 = require("../utils");

var _constants2 = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["dataTestId", "onClick", "expandableContent", "expandableTriggerText", "shouldVisuallyHideTriggerText", "expandableContentHasBackgroundColor", "expandableRowHasTopBorder", "aria-label", "actionLabel", "disabled", "disabledActionLabel"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ActionTd = (0, _context.styledWithTheme)(_html.TdElement)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    width: _constants2.ACTION_BUTTON_WIDTH + 2 * selectors.space(_constants.CELL_SPACING_HORIZONTAL)
  };
});
var StyledButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return "\n  border-color: transparent;\n  background-color: transparent;\n  margin: auto ".concat(_constants2.ACTION_BUTTON_WIDTH / 2, "px auto auto;\n\n  :focus,\n  :hover {\n    border-color: ").concat(selectors.color('neutral70'), ";\n  }\n");
});

var DisabledActionButton = function DisabledActionButton(_ref3) {
  var ariaLabel = _ref3['aria-label'],
      actionLabel = _ref3.actionLabel;
  return (0, _core.jsx)(StyledButton, {
    "aria-label": ariaLabel,
    icon: (0, _core.jsx)(_icons.IconMinus, {
      title: actionLabel
    }),
    size: _button.ButtonSize.Small,
    variant: _button.ButtonVariant.Tertiary,
    "aria-disabled": true
  });
};

var TableRow = /*#__PURE__*/(0, _react.memo)(function (_ref4) {
  var tableRowKey = _ref4.tableRowKey,
      data = _ref4.data,
      index = _ref4.index,
      columns = _ref4.columns,
      attributes = _ref4.attributes,
      isStriped = _ref4.isStriped,
      isExpanded = _ref4.isExpanded,
      toggleExpanded = _ref4.toggleExpanded,
      actionColumnIndex = _ref4.actionColumnIndex,
      isSorted = _ref4.isSorted,
      spacing = _ref4.spacing;
  var dataTestId = attributes.dataTestId,
      onClick = attributes.onClick,
      getRowExpandableContent = attributes.expandableContent,
      expandableTriggerText = attributes.expandableTriggerText,
      shouldVisuallyHideTriggerText = attributes.shouldVisuallyHideTriggerText,
      expandableContentHasBackgroundColor = attributes.expandableContentHasBackgroundColor,
      expandableRowHasTopBorder = attributes.expandableRowHasTopBorder,
      ariaLabel = attributes['aria-label'],
      actionLabel = attributes.actionLabel,
      disabled = attributes.disabled,
      disabledActionLabel = attributes.disabledActionLabel,
      trProps = (0, _objectWithoutProperties2.default)(attributes, _excluded);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilTableRow',
    dataTestId: dataTestId
  });
  var isExpandable = !!toggleExpanded && !onClick;
  var isActionCustomPosition = !!(actionColumnIndex || actionColumnIndex === 0);

  if (isStriped && index % 2 === 0) {
    isStriped = false;
  }

  var handleClick = !!onClick && !disabled ? function (event) {
    return onClick({
      data: data,
      index: index,
      event: event
    });
  } : undefined;
  var handleActionButtonClick = !!onClick && !disabled ? function (event) {
    event.stopPropagation();
    onClick({
      data: data,
      index: index,
      event: event
    });
  } : undefined;
  var handleToggleExpanded = !!toggleExpanded ? function () {
    return toggleExpanded(index);
  } : undefined;
  var baseColumns = columns.map(function (_ref5, colIndex) {
    var accessor = _ref5.accessor,
        CellContent = _ref5.cellComponent,
        textAlign = _ref5.textAlign,
        verticalAlign = _ref5.verticalAlign,
        width = _ref5.width,
        hasReducedSpacing = _ref5.hasReducedSpacing,
        _ref5$dataCellType = _ref5.dataCellType,
        dataCellType = _ref5$dataCellType === void 0 ? _interfaces.CellType.Data : _ref5$dataCellType;
    var cellData = (0, _utils2.applyAccessor)(accessor, data, index);
    var isCellTypeHeader = dataCellType === _interfaces.CellType.Header;
    var Cell = isCellTypeHeader ? _html.ThElement : _html.TdElement;
    var dataTypeCellProps = isCellTypeHeader ? {
      scope: 'row'
    } : {};
    var cellKey = tableRowKey !== undefined ? tableRowKey + colIndex : colIndex;
    return (0, _core.jsx)(Cell, (0, _extends2.default)({
      key: cellKey,
      isStriped: isStriped,
      textAlign: textAlign,
      verticalAlign: verticalAlign,
      width: width,
      "aria-label": ariaLabel,
      hasReducedSpacing: hasReducedSpacing
    }, dataTypeCellProps), !!CellContent ? (0, _core.jsx)(CellContent, {
      data: cellData,
      index: index
    }) : cellData);
  }); // Used to calculate the maximal number of expanded rows to add using the column-based config.

  var maxExpandableRows = (0, _react.useMemo)(function () {
    return isExpandable && !getRowExpandableContent ? (0, _expandable.getMaxExpandableRows)(columns, data, index) : 0;
  }, [columns, data, index, isExpandable, getRowExpandableContent]);

  var ExpandableCommonProps = _objectSpread({
    data: data,
    index: index,
    isExpanded: isExpanded,
    isStriped: isStriped,
    expandableContentHasBackgroundColor: expandableContentHasBackgroundColor,
    expandableRowHasTopBorder: expandableRowHasTopBorder,
    isSorted: isSorted,
    spacing: spacing,
    columns: columns
  }, trProps);

  var renderDisabledActionButton = function renderDisabledActionButton() {
    return (0, _core.jsx)(DisabledActionButton, {
      "aria-label": disabledActionLabel,
      actionLabel: actionLabel
    });
  };

  var renderActionButton = function renderActionButton() {
    return (0, _core.jsx)(_button.Button, {
      icon: (0, _core.jsx)(_icons.IconChevronRight, {
        title: actionLabel
      }),
      onClick: handleActionButtonClick,
      size: _button.ButtonSize.Small,
      variant: _button.ButtonVariant.Tertiary
    });
  };

  var renderExpandButton = function renderExpandButton() {
    return (0, _core.jsx)(_expandable.ExpandableTriggerButton, {
      isExpanded: isExpanded,
      toggleExpanded: handleToggleExpanded,
      shouldVisuallyHideTriggerText: shouldVisuallyHideTriggerText,
      triggerText: expandableTriggerText
    });
  };

  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_html.TrElement, (0, _extends2.default)({
    onClick: handleClick,
    isClickable: !!onClick,
    disabled: disabled,
    hasBackgroundColor: isStriped
  }, dataTestProps, trProps), isActionCustomPosition ? baseColumns.slice(0, actionColumnIndex) : baseColumns, !!onClick && (0, _core.jsx)(ActionTd, {
    hasReducedSpacing: true
  }, disabled ? renderDisabledActionButton() : renderActionButton()), isExpandable && !!toggleExpanded && (0, _core.jsx)(_html.TdElement, {
    hasReducedSpacing: true,
    textAlign: "right"
  }, disabled ? renderDisabledActionButton() : renderExpandButton()), isActionCustomPosition ? baseColumns.slice(actionColumnIndex) : null), isExpandable && !disabled && !!getRowExpandableContent ? (0, _core.jsx)(_expandable.ExpandableRowsByRows, (0, _extends2.default)({}, ExpandableCommonProps, {
    expandableContent: getRowExpandableContent
  })) : (0, _core.jsx)(_expandable.ExpandableRowsByColumn, (0, _extends2.default)({}, ExpandableCommonProps, {
    maxExpandableRows: maxExpandableRows,
    actionColumnIndex: actionColumnIndex,
    isActionCustomPosition: isActionCustomPosition,
    ariaLabel: ariaLabel
  })));
});
TableRow.displayName = 'TableRow';
var _default = TableRow;
exports.default = _default;